import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import routes from './router';
import VueLogger from 'vuejs-logger';
import VTooltip from 'v-tooltip'
import DotLoader from 'vue-spinner/src/DotLoader.vue';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Clipboard from 'v-clipboard';
import VueNoty from 'vuejs-noty';

const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};


Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.component('DotLoader', DotLoader);
Vue.component('ClipLoader', ClipLoader);
Vue.use(VueLogger, options);
Vue.use(VueRouter);
Vue.use(Clipboard);
Vue.use(VueNoty, {
    timeout: 4000,
    layout: 'bottomRight',
    theme: 'metroui'
});
Vue.use(VTooltip, {
    defaultTrigger: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 'click' : 'hover',
    defaultOffset: 7,
    defaultDelay: 200,
});
Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

const router = new VueRouter({routes});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
